import './styles.scss'
import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import { smartChat } from 'api'
import ModalWrapper from 'components/ModalWrapper'
import { Text } from 'components/SmartChatView/Fields'

const MessageType = (props) => {
  const { toggle, group, getMessageGroup, isOpen, groupsInfo } = props
  const [messageError, setMessageError] = React.useState(null)
  const [type, setType] = React.useState(group?.name || '')
  const [submitting, setSubmitting] = React.useState(false)

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) setMessageError(null)

    return () => isSubscribed = false
  }, [type])

  React.useEffect(() => {
    let isSubscribed = true

    if (isSubscribed) {
      if (group?.name)
        setType(group.name)
      else if (!group)
        setType('')
    }

    return () => isSubscribed = false
  }, [group])

  const onClick = async () => {
    if (!type || type.length < 0) {
      setMessageError(I18n.t('chatbot_error_name_require'))
      return
    }

    if (groupsInfo.groups.some(it => it.name.toUpperCase() === type.toUpperCase())) {
      setMessageError(I18n.t('chatbot_error_name_exists'))
      return
    }

    if (group?._id)
      editGroup({ groupMessagesId: groupsInfo._id, groupId: group._id, name: type })
    else
      saveGroup({ name: type })
  }

  const saveGroup = async (data) => {
    setSubmitting(true)
    smartChat.addGroup(data).then(result => {
      setSubmitting(false)
      getMessageGroup({ group: result.data.group, mode: 'add' })
      setType('')
      toggle()
    }).catch(() => {
      setSubmitting(false)
    })
  }

  const editGroup = async (data) => {
    setSubmitting(true)
    smartChat.editNameGroup(data).then(result => {
      setSubmitting(false)
      getMessageGroup({ group: { _id: data.groupId, name: data.name }, mode: 'edit' })
      setType('')
      toggle()
    }).catch(() => {
      setSubmitting(false)
    })
  }

  return (
    <ModalWrapper
      isOpen={isOpen}
      toggle={toggle}
      header={!group ? I18n.t('dashboard_add-message-type') : I18n.t('dashboard_edit-message-type')}
      eventBtnTxt={I18n.t('dashboard_save')}
      eventBtn={onClick}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={submitting}
      error={messageError}
      contentClassName='smartchat-modal'
      body={
        <Text
          isRequired
          label={I18n.t('dashboard_name')}
          placeholder={I18n.t('dashboard_example_welcome')}
          value={type}
          onChange={setType}
        />
      }
    />
  )
}

export default MessageType
